import { useState, useCallback } from "react";

/**
 * Hook para peticiones POST/PUT/PATCH/DELETE que no se ejecutan automáticamente
 *
 * @param {Function} apiFunction - Función de API a ejecutar
 * @returns {Object} Objeto con data, error, isLoading y mutate
 *
 * @example
 * const { data, error, isLoading, mutate: createUser } = useMutation(createUsuario);
 *
 * const handleSubmit = async () => {
 *   const result = await createUser(userData); // Obtiene la data retornada
 * };
 */
export const useMutation = (apiFunction) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const mutate = useCallback(async (params) => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await apiFunction(params);
      setData(result);
      return result;
    } catch (err) {
      setError(err);
      console.error("Error useMutation:", err.message || err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData(null);
    setError(null);
    setIsLoading(false);
  }, []);

  return { data, error, isLoading, mutate, reset };
};
